var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200",
    transform: "translate(-1457 -7590)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    transform: "translate(1457 7590)",
    fill: "none",
    stroke: "#383535",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M13-13H1a1,1,0,0,0-1,1.009V-.009A1,1,0,0,0,1,1H13A1.007,1.007,0,0,0,14-.009V-11.991A1.007,1.007,0,0,0,13-13ZM4.231-1H2.156V-7.681H4.234V-1ZM3.194-8.594a1.2,1.2,0,0,1-1.2-1.2,1.2,1.2,0,0,1,1.2-1.2A1.206,1.206,0,0,1,4.4-9.8,1.2,1.2,0,0,1,3.194-8.594ZM12.009-1H9.934V-4.25c0-.775-.016-1.772-1.078-1.772-1.081,0-1.247.844-1.247,1.716V-1H5.534V-7.681H7.525v.913h.028A2.185,2.185,0,0,1,9.519-7.847c2.1,0,2.491,1.384,2.491,3.184Z",
    transform: "translate(1470 7616)",
    fill: "#afafaf",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.70ee7e6f0f8cd07dfa1b78b672ec2dee.svg";
export { ForwardRef as ReactComponent };